import { useEffect } from 'react';
import { useDocumentTitle } from '~src/hooks/useDocumentTitle';
import styles from './index.module.less';
import { SafeArea } from 'antd-mobile';

const WalletDescription = () => {
  useDocumentTitle('绿喵钱包说明');
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [])
  return <div className={styles.container}>
    <span className={styles.paragraph} style={{ marginTop: '20px' }}>
      尊敬的用户，为保障您的合法权益，请您在充值前仔细阅读本《绿喵钱包说明》(以下简称“本说明”)，以了解绿喵平台的充值、返现及余额使用规则并避免产生误解。当您点击“确认充值”按钮，即视为您已阅读、理解本说明，并同意按照本说明的规则进行充值、参与返现及/或使用账户余额。
    </span>
    <span className={styles.title}>
      一、钱包说明
    </span>
    <div className={styles.paragraph}>
      1、充值本金：您通过绿喵客户端（包括绿喵小程序、App）向您已注册的用户账号实际支付的金额。<br />
      2、账户余额：您的账号中显示的余额，包括(1)充值本金；(2)绿喵通过“充值返利"活动赠送的返利金额。<br />
      3、账户余额有效期:用户账户余额的有效期为自充值之日起至使用完毕为止。<br />
      4、充值返现活动规则：我们会通过绿喵主页面及/或具体活动页面及时公布不同数额的充值本金可享受的返利金额，例如：充值100元返利10元，则您账户可得金额为110元。具体活动详情，您可通过充值或关注我们的活动页面进行了解。<br />
      5、账户余额的使用规则<br />
      <span className={styles.paddingleft}>
        （1）账户余额仅可用于支付电动汽车充电费，不可用于购买商品、转移或转赠。<br />
        （2）用户账号使用期间，充值本金将会被优先使用。<br />
        （3）充值本金中未使用部分，可申请退款（例如：若您充值的本金为100元，且您尚未消费，则您可申请退还100元；若您充值本金为100元，且您已消费50元，则您可申请退还50元，以此类推)。<br />
        （4）返利金额仅可用于电动汽车充电费，不可用于购买商品、转移、转赠或退款。<br />
        （5）鉴于返利金额以您账户可合法有效且有可使用的充值本金为前提条件，返现金额在如下情况下将会失效：<br />
        <span className={styles.paddingleft}>
          a）您主动注销用户账户；<br />
          b）您选择退回押金或未使用的充值本金；<br />
          c）因涉嫌作弊、违规操作等导致您的用户账户被冻结或者关闭。<br />
        </span>
      </span>
      6、保证与承诺<br />
      <span className={styles.paddingleft}>您完全理解并同意，绿喵所提供的包括"充值返利"在内的、与充值相关的优惠活动仅适用于正当、合法按照《用户协议》使用我们服务的用户。一旦发现您的用户账号存在任何利用前述规则从事作弊、违规操作的行为，或存在其他以获取不正当经济利益为目的的情形（以下简称“<span className={styles.bold}>作弊行为</span>”），绿喵有权冻结或关闭您的用户账号以及任何其他与作弊行为相关的用户账号，并收回或取消已赠送的返现金额及/或追回作弊行为取得的所有不正当的经济利益，并且绿喵保留停止向您提供服务以及根据作弊行为的严重程度进一步追究法律责任的权利。</span>
      7、特别说明<br />
      <span className={styles.paddingleft}>您完全理解并同意，绿喵有权随时修改本说明的内容，更新后的说明将在绿喵客户端发布。更新后的说明一经发布，即视为绿喵已将更新内容告知用户；同时，绿喵也可通过其他适当方式告知用户。如果您在绿喵发布了更新版本的充值说明后选择继续充值，即表示您同意并接受修改后的本说明并受其约束；如果您不同意对我们对本说明的修改，请立即放弃充值并停止使用我们提供的产品和服务。</span>
    </div>
    <span className={styles.title}>
      二、提现说明
    </span>
    <span className={styles.paragraph}>
      1、本提现为充值本金的原路退回。<br />
      2、用户存在尚未结束的充电订单时，无法进行提现操作。<br />
      3、绿喵支持账户余额提现，账户余额中包括了参与充值返利等优惠活动所得的金额的，申请提现时相应优惠金额将被扣除，仅充值本金可以提现。<br />
      4、充值本金原路退回的到账时间以充值渠道（如微信、支付宝等）为准(每个渠道的期限可能不一致)，请耐心等待；提现遇到问题的可申请人工处理，绿喵客服将在15个工作日内响应用户的人工提现申请，具体到账时间以对应银行的到账时间为准。<br />
      5、本提现仅支持通过正规官方渠道充值到个人账户余额中的充值本金的提现，通过他人代充等途径的不包含在内。<br />
    </span>
    <span className={styles.paragraph}>
      {`如有疑问，可至【我的】-【联系客服】咨询`}
    </span>
    <SafeArea position='bottom' />
  </div>
}
export default WalletDescription
